import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from "@angular/core";
import { Validators } from "@angular/forms";
import * as _ from "lodash";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { Alert } from "src/app/shared/class/Alert";
import { globalConst } from "src/app/shared/helpers/constants";
import { Helper } from "src/app/shared/helpers/helper";
import { Agent } from "src/app/shared/models/agent.model";
moment.locale("pt-br");
export class ServiceRequestDetailsComponent {
    constructor(authService, spinner, route, serviceRequestService, fb, router) {
        this.authService = authService;
        this.spinner = spinner;
        this.route = route;
        this.serviceRequestService = serviceRequestService;
        this.fb = fb;
        this.router = router;
        this.goback = "../list";
        this.queryParams = {};
        this.now = Date.now();
        this.subscription = new Subscription();
        this.userLogged = {};
        this.maxAttachment = globalConst.attachment.max;
        this.attachmentsFile = [];
        this.agents = [];
        this.disableRegional = false;
        this.companyOptions = [];
        this.filteredCompanyOptions = this.companyOptions;
        this.regionalOptions = [];
        this.filteredRegionalOptions = this.regionalOptions;
        this.serviceLocalOptions = [];
        this.filteredServiceLocalOptions = this.serviceLocalOptions;
        this.allOptions = {
            id: "T",
            description: "TODAS",
        };
        this.maxCaracteres = 2000;
        this.globalConst = globalConst;
        this.userLogged = this.authService.getUserLogged();
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.spinner.show();
            try {
                this.route.queryParams.subscribe((params) => (this.queryParams = params));
                this.serviceRequestForm = this.fb.group({
                    observation: this.fb.control("", Validators.required),
                    company: this.fb.control("", Validators.required),
                    regional: this.fb.control("", Validators.required),
                    serviceLocal: this.fb.control("", Validators.required),
                    priority: this.fb.control("", Validators.required),
                    attendance_type: this.fb.control("", Validators.required),
                    line: this.fb.control("", Validators.required),
                    whatsapp_ddi: this.fb.control("", [
                        Validators.required,
                        Validators.maxLength(2),
                    ]),
                    whatsapp_ddd: this.fb.control("", [
                        Validators.required,
                        Validators.maxLength(3),
                    ]),
                    whatsapp_number: this.fb.control("", [
                        Validators.required,
                        Validators.maxLength(11),
                    ]),
                    email_cc: this.fb.control("", [Validators.maxLength(300)]),
                });
                if (this.queryParams.id) {
                    this.loadServiceRequest(this.queryParams.id);
                    this.associateAgentForm = this.fb.group({
                        agentId: this.fb.control(null, Validators.required),
                    });
                    yield this.loadAgents();
                }
                if (!this.queryParams.id) {
                    yield this.loadCompanyOptions();
                    yield this.loadRegionalOptions();
                    yield this.loadServiceLocal();
                    this.listenChangeCompany();
                    this.listenChangeRegional();
                    this.listenChangeServiceLocal();
                }
                this.spinner.hide();
            }
            catch (error) {
                this.spinner.hide();
                console.error(error);
            }
        });
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    listenChangeCompany() {
        const control = this.serviceRequestForm.controls.company;
        control.valueChanges.subscribe(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!control.errors &&
                control.value.alternativeIdentifier !== undefined) {
                try {
                    this.spinner.show();
                    this.regionalOptions = [];
                    this.serviceRequestForm.controls.regional.setValue(null);
                    yield this.loadRegionalOptions();
                    this.regionalOptions = this.regionalOptions.filter((obj) => obj.companyAlternativeIdentifier ===
                        control.value.alternativeIdentifier);
                    this.filteredRegionalOptions = this.regionalOptions;
                    if (!this.regionalOptions.length) {
                        Alert.warning(Alert.getMessage().errors.regional.emptySearch);
                    }
                    this.serviceLocalOptions = [];
                    this.filteredServiceLocalOptions = this.serviceLocalOptions;
                    yield this.loadServiceLocal();
                    this.loadAllServiceLocalsByCompany();
                    // this.disableRegional = (this.userLogged.type !== globalConst.defaults.user.client);
                    this.serviceRequestForm.controls.regional.setValue({});
                    this.spinner.hide();
                }
                catch (error) {
                    this.spinner.hide();
                    Helper.handleError(error);
                }
            }
        }));
    }
    listenChangeRegional() {
        const control = this.serviceRequestForm.controls.regional;
        control.valueChanges.subscribe(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!control.errors && control.value.id !== undefined) {
                try {
                    this.spinner.show();
                    yield this.loadServiceLocal();
                    if (control.value.id === "T") {
                        this.loadAllServiceLocalsByCompany();
                    }
                    else {
                        this.serviceLocalOptions = this.serviceLocalOptions.filter((obj) => obj.regionalId === control.value.id);
                        this.filteredServiceLocalOptions = this.serviceLocalOptions;
                        if (!this.serviceLocalOptions.length) {
                            Alert.warning(Alert.getMessage().errors.serviceLocal.emptySearch);
                        }
                    }
                    this.spinner.hide();
                }
                catch (error) {
                    this.spinner.hide();
                    Helper.handleError(error);
                }
            }
        }));
    }
    listenChangeServiceLocal() {
        const control = this.serviceRequestForm.controls.serviceLocal;
        control.valueChanges.subscribe(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!control.errors) {
                this.serviceRequestForm.controls.regional.setValue(this.regionalOptions.find((obj) => obj.id === control.value.regionalId));
            }
        }));
    }
    loadAllServiceLocalsByCompany() {
        const auxServiceLocal = [];
        this.serviceRequestForm.controls.serviceLocal.setValue(null);
        this.regionalOptions.map((regional) => {
            // tslint:disable-next-line: max-line-length
            this.serviceLocalOptions
                .filter((obj) => obj.regionalId === regional.id)
                .map((serviceLocal) => auxServiceLocal.push(serviceLocal));
        });
        this.serviceLocalOptions = auxServiceLocal;
        this.filteredServiceLocalOptions = this.serviceLocalOptions;
        if (!this.serviceLocalOptions.length) {
            Alert.warning(Alert.getMessage().errors.serviceLocal.emptySearch);
        }
    }
    loadCompanyOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getCompanies();
                this.companyOptions =
                    this.userLogged.type === globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.userLogged.companiesAssociate;
                this.filteredCompanyOptions = this.companyOptions;
                if (!this.companyOptions.length) {
                    Alert.warning(Alert.getMessage().errors.company.emptySearch);
                }
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadRegionalOptions() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getRegionals();
                this.regionalOptions =
                    this.userLogged.type === globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.userLogged.regionalsAssociate;
                this.filteredRegionalOptions = this.regionalOptions;
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadServiceLocal() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getServiceLocals();
                this.serviceLocalOptions =
                    this.userLogged.type === globalConst.defaults.user.admin
                        ? data.status === undefined
                            ? data
                            : []
                        : this.userLogged.serviceLocalsAssociate;
                this.filteredServiceLocalOptions = this.serviceLocalOptions;
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadAgents() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getAgents();
                this.agents =
                    data.status === undefined ? Agent.orderAgentByName(data) : [];
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    loadServiceRequest(serviceRequestId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getSchedule(serviceRequestId);
                this.loadedServiceRequest = data.status === undefined ? data : [];
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    onSubmit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.serviceRequestForm.invalid) {
                this.spinner.show();
                const date = new Date();
                const serviceRequest = {
                    date: `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`,
                    hour: moment().format("LT"),
                    observation: this.serviceRequestForm.value.observation,
                    serviceLocalId: this.serviceRequestForm.value.serviceLocal.id,
                    serviceLocalDescription: this.serviceRequestForm.value.serviceLocal.description,
                    serviceLocalEmail: this.serviceRequestForm.value.serviceLocal.email,
                    companyDescription: this.serviceRequestForm.value.company.description,
                    regionalDescription: this.serviceRequestForm.value.regional.description,
                    priority: this.serviceRequestForm.value.priority,
                    attendance_type: this.serviceRequestForm.value.attendance_type,
                    line: this.serviceRequestForm.value.line,
                    whatsapp_ddi: this.serviceRequestForm.value.whatsapp_ddi,
                    whatsapp_ddd: this.serviceRequestForm.value.whatsapp_ddd,
                    whatsapp_number: this.serviceRequestForm.value.whatsapp_number,
                    email_cc: this.serviceRequestForm.value.email_cc,
                };
                const verifyOpening = yield this.serviceRequestService.verifyOpening(serviceRequest.serviceLocalId);
                if (verifyOpening) {
                    this.spinner.hide();
                    Alert.question(Alert.getMessage().question.openSchedule).then((response) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        if (response.value) {
                            yield this.createSchedule(Object.assign({}, serviceRequest));
                        }
                    }));
                }
                else {
                    yield this.createSchedule(Object.assign({}, serviceRequest));
                }
            }
        });
    }
    createSchedule(serviceRequest) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.spinner.show();
            this.serviceRequestService
                .createSchedule(Object.assign({}, serviceRequest, { userId: this.userLogged.id, userEmail: this.userLogged.email, requester: this.userLogged.name, requesterEmail: this.userLogged.email, serviceLocalEmail: serviceRequest.serviceLocalEmail || "" }))
                .subscribe((resource) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                /* const body = {
                  requester: this.userLogged.name,
                  requesterEmail: this.userLogged.email,
                  scheduleId: resource.resourceId,
                  // serviceLocalEmail: serviceRequest.serviceLocalEmail,
                  ...serviceRequest,
                }; */
                this.spinner.hide();
                Alert.success("Solicitação aberta com sucesso").then(() => {
                    this.router.navigate(["../serviceRequest/list"]);
                });
                /*  this.spinner.show("mailSpinner");
                await this.serviceRequestService.insertSchedule(body);
                await this.serviceRequestService.associateSchedule(
                  resource.resourceId
                );
                this.spinner.hide("mailSpinner");
                Alert.success(Alert.getMessage().success.sendEmail).then(() => {
                  this.router.navigate(["../serviceRequest/list"]);
                }); */
            }), (error) => {
                this.spinner.hide();
                console.error(error);
            });
        });
    }
    registerDocument(file) {
        if (file.target.files.length > this.maxAttachment) {
            Alert.error(Alert.getMessage().errors.fileLimit);
        }
        else {
            const totalAttachments = file.target.files.length;
            for (file of file.target.files) {
                const reader = new FileReader();
                const extension = file.name.split(".").reverse()[0];
                const fileName = file.name;
                const allowExtensions = ["jpeg", "jpg", "png"];
                const checkExtension = allowExtensions.find((extensions) => extensions === extension);
                if (checkExtension === undefined) {
                    // tslint:disable-next-line: max-line-length
                    Alert.error(`Ocorreu um erro ao anexar o arquivo: ${file.name} a extensão .${extension} não é permitida utilize as extensões: JPEG, JPG, PNG`);
                    continue;
                }
                const totalFiles = this.attachmentsFile.length + totalAttachments;
                if (totalFiles <= this.maxAttachment) {
                    reader.readAsDataURL(file);
                    reader.onload = () => {
                        this.attachmentsFile.push({
                            name: fileName,
                            extension,
                            blob: reader.result,
                        });
                    };
                }
                else {
                    Alert.error(Alert.getMessage().errors.fileLimit);
                }
            }
        }
    }
    deleteDocument(name) {
        Alert.question(Alert.getMessage().question.delete).then((response) => {
            if (response.value) {
                const findPos = this.attachmentsFile.indexOf(this.attachmentsFile.find((attachment) => attachment.name === name));
                this.attachmentsFile.splice(findPos, 1);
            }
        });
    }
    associateAgent() {
        if (this.associateAgentForm.valid) {
            this.spinner.show();
            this.subscription.add(this.serviceRequestService
                .updateServiceRequestAgent(this.associateAgentForm.get("agentId").value, this.loadedServiceRequest.id)
                .subscribe(() => {
                this.spinner.hide();
                Alert.success(Alert.getMessage().success.save);
            }, (error) => {
                if (error.status === 200 || error.status === 201) {
                    this.spinner.hide();
                    Alert.success(Alert.getMessage().success.save).then(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        this.spinner.show();
                        yield this.serviceRequestService.updateSchedule(this.loadedServiceRequest.id);
                        yield this.loadServiceRequest(this.loadedServiceRequest.id);
                        this.spinner.hide();
                        this.spinner.show("mailSpinner");
                        const emailSended = yield this.serviceRequestService.sendAgentEmail(this.associateAgentForm.get("agentId").value, this.loadedServiceRequest.id);
                        if (!_.isEmpty(emailSended.error)) {
                            this.spinner.hide("mailSpinner");
                            Alert.warning(Alert.getMessage().errors.sendEmail).then(() => {
                                this.router.navigate(["../serviceRequest/list"]);
                            });
                        }
                        else {
                            this.spinner.hide("mailSpinner");
                            Alert.success(Alert.getMessage().success.sendEmail).then(() => {
                                this.router.navigate(["../serviceRequest/list"]);
                            });
                        }
                    }));
                }
                else {
                    this.spinner.hide();
                    Helper.handleError(error);
                }
            }));
        }
    }
    displayDescription(object) {
        return !_.isEmpty(object) ? `${object.description}` : "";
    }
    filterCompanyOptions(value) {
        value = value.trim();
        this.filteredCompanyOptions = value
            ? this._filterCompany(value)
            : this.companyOptions.slice();
    }
    _filterCompany(name) {
        const filterValue = name.toLowerCase();
        const searchName = this.companyOptions.filter((option) => option.description.toLowerCase().includes(filterValue));
        if (searchName.length) {
            return searchName;
        }
        return this.companyOptions.filter((option) => option.description.toLowerCase().includes(filterValue));
    }
    filterRegionalOptions(value) {
        value = value.trim();
        this.filteredRegionalOptions = value
            ? this._filterRegional(value)
            : this.regionalOptions.slice();
    }
    _filterRegional(name) {
        const filterValue = name.toLowerCase();
        const searchName = this.regionalOptions.filter((option) => option.description.toLowerCase().includes(filterValue));
        if (searchName.length) {
            return searchName;
        }
        return this.regionalOptions.filter((option) => option.description.toLowerCase().includes(filterValue));
    }
    filterServiceLocalOptions(value) {
        value = value.trim();
        this.filteredServiceLocalOptions = value
            ? this._filterServiceLocal(value)
            : this.serviceLocalOptions.slice();
    }
    _filterServiceLocal(name) {
        const filterValue = name.toLowerCase();
        const searchName = this.serviceLocalOptions.filter((option) => option.description.toLowerCase().includes(filterValue));
        if (searchName.length) {
            return searchName;
        }
        return this.serviceLocalOptions.filter((option) => option.description.toLowerCase().includes(filterValue));
    }
}
